"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AptosThirdpartInjectProvider = void 0;
const protocol_1 = require("../../../protocol");
const walletAdapter_1 = require("./walletAdapter");
const utils_1 = require("../../../utils");
const misc_1 = require("./misc");
class AptosThirdpartInjectProvider {
    constructor(walletAdapter) {
        this.walletAdapter = walletAdapter;
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.walletAdapter.disconnect();
        });
    }
    getVersion() {
        return this.walletAdapter.version;
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.walletAdapter.connect();
            let publicAccount = this.walletAdapter.publicAccount;
            let address = publicAccount.address;
            let publicKey = publicAccount.publicKey.toString();
            let extra = {};
            extra[protocol_1.APTOS_CHAINS.MAINNET] = { publicKey: publicKey };
            return {
                namespace: protocol_1.NameSpaceKeyAptos,
                addresses: [`${protocol_1.APTOS_CHAINS.MAINNET}:${address}`],
                methods: [],
                extra: extra
            };
        });
    }
    supportChains(chains) {
        if (this.walletAdapter.readyState !== walletAdapter_1.WalletReadyState.Installed) {
            return false;
        }
        if (chains.length === 1 && chains[0] === protocol_1.APTOS_CHAINS.MAINNET) {
            return true;
        }
        return false;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                try {
                    (0, utils_1.logDebug)("AptosStandardProvider send request:", JSON.stringify(request));
                }
                catch (e) {
                }
                this.confirmNetwrok(request.chainId);
                const method = request.method;
                let result;
                if (request.injectParams && this.walletAdapter) {
                    let originalRarams = request.injectParams;
                    switch (method) {
                        case "aptos_signTransaction":
                            let injectSignResult = yield this.walletAdapter.signTransaction(request.params);
                            result = {
                                method: "aptos_signTransaction",
                                result: injectSignResult
                            };
                            break;
                        case "aptos_signMessage":
                            let signMessageResult = yield this.walletAdapter.signMessage(originalRarams);
                            if (typeof signMessageResult === 'object' && "signature" in signMessageResult) {
                                signMessageResult = signMessageResult.signature;
                            }
                            result = {
                                method: "aptos_signMessage",
                                result: signMessageResult
                            };
                            break;
                        case "aptos_signAndSubmitTransaction":
                            let transactionResult = yield this.walletAdapter.signAndSubmitTransaction(request.params);
                            result = {
                                method: "aptos_signAndSubmitTransaction",
                                result: transactionResult.hash
                            };
                            break;
                    }
                }
                return result;
            }
            catch (e) {
                (0, utils_1.logDebug)("aptosProvider send error:", e);
                throw e;
            }
        });
    }
    removeListener() {
    }
    addAccountChangedListener(listener) {
        this.walletAdapter.onAccountChange((account) => {
            listener === null || listener === void 0 ? void 0 : listener(account === null || account === void 0 ? void 0 : account.address);
        });
    }
    confirmNetwrok(chainid) {
        var _a;
        if (chainid !== utils_1.chainName2IdMap.get(protocol_1.APTOS_CHAINS.MAINNET)) {
            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
        }
        let walletNetwork = this.walletAdapter.network;
        if (((_a = walletNetwork.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == misc_1.AptosNetwork.MAINNET) {
            return;
        }
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
    }
}
exports.AptosThirdpartInjectProvider = AptosThirdpartInjectProvider;
